import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex relative" }
const _hoisted_2 = {
  key: 2,
  class: "absolute flex top-0 left-0 w-full h-full bg-brand-black z-50"
}
const _hoisted_3 = { class: "bg-brand-black flex w-full p-4 py-5 font-medium text-xl text-white border-b-4 border-brand-dark-gray max-h-80 overflow-scroll" }
const _hoisted_4 = { class: "text-sm text-white p-3" }
const _hoisted_5 = { class: "text-sm" }

import {
  alertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTextarea,
  IonToolbar,
  modalController,
  toastController,
} from '@ionic/vue';
import {computed, onMounted, PropType, Ref, ref} from 'vue';
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import {usePremium} from "@/composables/usePremium";
import {Mentionable} from 'vue-mention'
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {UserReviewInterface} from "@/interfaces/UserReviewInterface";
import {AccountType} from "@/definitions/AccountType";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewUserPage',
  props: {
  user: {
    type: Object as PropType<UserBasicInformationInterface>,
    required: true
  },
  review: {
    type: Object as PropType<UserReviewInterface>,
    required: false
  },
},
  setup(__props) {

const props = __props

const loading = ref(true)
const busy = ref(false)
const posting = ref(false)

const postContent = ref('')

onMounted(async () => {

  if (props.review) {
    postContent.value = props.review.original_text
  }

  loading.value = false
})


const goBack = async () => {

  if (busy.value || posting.value) return

  const modal = await alertController.create({
    header: props.review ? 'Discard Changes' : 'Discard Review',
    message: props.review ? 'Are you sure you want to discard any changes to this review?' : 'Are you sure you want to discard this review?',
    buttons: [
      {
        text: 'Yes',
        role: 'destructive',
        handler: () => {
          modalController.dismiss()
        }
      },
      {
        text: 'No',
      },

    ]
  })

  await modal.present()

}


const canPost = computed(() => {
  return postContent.value.length > 3
})

const postReview = async () => {

  if (!canPost.value) return

  try {
    posting.value = true
    await ApiService.User().addReview(props.user.id, postContent.value)
    Observable.emit(ObservableEvent.UserReviewsChanged)
    await modalController.dismiss()
  } catch (e: any) {

    posting.value = false
    if (e.status === 429) {
      return usePremium().presentPayWall({
        text: e.data.message,
        callback: () => {
          //
        }
      });
    }

    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
  }
}

const updateReview = async () => {

  if (!canPost.value) return
  if (!props.review) return

  try {
    posting.value = true

    const review: UserReviewInterface = props.review
    review.text = postContent.value

    await ApiService.User().updateReview(review)
    Observable.emit(ObservableEvent.UserReviewsChanged)
    await modalController.dismiss()
    posting.value = false
  } catch (e: any) {
    const toast = await toastController.create({
      message: e.data.message,
      duration: 3000,
      position: 'bottom',
      color: 'danger'
    });
    await toast.present();
    posting.value = false
  }
}

const loadingUsers = ref(false)
const mentionableUsers: Ref<any[]> = ref([])

const mentionableUserId = (name: string) => {
  return (mentionableUsers.value.find((user: UserBasicInformationInterface) => {
    return user.name === name
  })).id
}

const loadUsers = async (searchText = '') => {
  loadingUsers.value = true
  mentionableUsers.value = await fetchUsers(searchText)
  loadingUsers.value = false
}

const fetchUsers = async (search: string) => {
  const results = await ApiService.Search().users(search)
  return results.map((result: UserBasicInformationInterface) => {
    return {
      value: result.name,
      label: result.name
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), { class: "!p-0 !m-0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { class: "justify-between flex w-full" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonButton), {
                    onClick: goBack,
                    class: "bg-brand-dark-gray rounded-md"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("svg", {
                        class: "fill-current text-white w-6 h-6 p-0.5",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512"
                      }, [
                        _createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
                      ], -1)
                    ]))]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_1, [
                    (!__props.review)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 0,
                          onClick: postReview,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Post ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (__props.review)
                      ? (_openBlock(), _createBlock(_unref(IonButton), {
                          key: 1,
                          onClick: updateReview,
                          class: "!text-xl"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: _normalizeClass({
                  'text-brand-light-gray' : !canPost.value,
                  'text-brand-lime' : canPost.value
                })
                            }, "Update ", 2)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (posting.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[4] || (_cache[4] = [
                          _createElementVNode("svg", {
                            class: "animate-spin m-auto h-5 w-5 text-brand-lime",
                            xmlns: "http://www.w3.org/2000/svg",
                            fill: "none",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("circle", {
                              class: "opacity-25",
                              cx: "12",
                              cy: "12",
                              r: "10",
                              stroke: "currentColor",
                              "stroke-width": "4"
                            }),
                            _createElementVNode("path", {
                              class: "opacity-75",
                              fill: "currentColor",
                              d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            })
                          ], -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Mentionable), {
              class: "w-full",
              keys: ['@'],
              items: mentionableUsers.value,
              offset: "6",
              onOpen: _cache[1] || (_cache[1] = ($event: any) => (loadUsers())),
              onSearch: _cache[2] || (_cache[2] = ($event: any) => (loadUsers($event))),
              "filtering-disabled": ""
            }, {
              "no-result": _withCtx(() => [
                _createElementVNode("div", _hoisted_4, _toDisplayString(loadingUsers.value ? 'Loading...' : 'No users found.'), 1)
              ]),
              "item-@": _withCtx(({ item }) => [
                _createElementVNode("div", _hoisted_5, " @" + _toDisplayString(item.value), 1)
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(IonTextarea), {
                  "auto-grow": "",
                  autocapitalize: "on",
                  modelValue: postContent.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((postContent).value = $event)),
                  placeholder: `Leave a ${__props.user.account_type === _unref(AccountType).Club ? 'review' : 'validation'} for ${__props.user.name}`
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["items"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})